// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dx1rz","largestCol":"styles_largestCol__2Hx9j","smallestCol":"styles_smallestCol__LPNdV"};